import { CardStack } from "./CardStack";
import { AnimatePresence } from "framer-motion";
import { testimonials } from "./TestimonialCard";
import { CompanyListFlow } from "./CompanyListFlow";
import { ConditionalLink } from "components/conditionalLink";
import { PHONE } from "constants/help";
import { WhatsApp } from "components/icons/WhatsApp";
import { FeatureMarket } from "./FeatureMarket";

export const Testimonial = ({ isSignin }: { isSignin?: boolean }) => {
  return (
    <AnimatePresence>
      <div className="t-hidden midLarge:t-flex t-flex-col t-justify-between t-bg-[url('static/images/AuthTestimonialBG.png')] t-bg-cover t-bg-center t-h-screen t-w-5/12 t-pb-12">
        <ConditionalLink to={`https://wa.me/${PHONE}`}>
          <button className="t-absolute t-bottom-8 -t-ml-[70px] t-z-50 t-flex t-items-center t-justify-center t-rounded-full t-border-0 t-bg-surface t-shadow-hover-card-shadow t-drop-shadow-bubble t-h-10 t-aspect-square">
            <WhatsApp className="t-text-[#25D366] t-size-7 -t-mt-0.5" />
          </button>
        </ConditionalLink>
        {isSignin ? (
          <FeatureMarket />
        ) : (
          <div className="t-flex t-flex-col t-h-full t-w-full">
            <div className="t-flex t-flex-col t-justify-center t-items-center t-flex-1 t-w-3/5 t-mx-auto">
              <CardStack items={testimonials} />
            </div>
            <div className="t-flex t-flex-col t-gap-7">
              <div className="t-w-80 t-text-center t-text-subtext t-text-yellow-30 t-mx-auto">
                Used by 500+ US startups to stay compliant, including over 5% of
                YC companies.
              </div>
              <CompanyListFlow />
            </div>
          </div>
        )}
      </div>
    </AnimatePresence>
  );
};
